module.exports = __webpack_public_path__ + "static/media/img_wear-insert-03.088355ae.svg";